import React from "react";
import { connect } from "react-redux";
import {
  removeField,
  handleHideStake,
} from "../../../redux/actions/betSlipActions";
import { Tooltip, Input, Spin, Icon, Select } from "antd";
import { SportIcon, Alert } from "../../";
import { SessionStorage, Cookies, Enums } from "../../../helpers";
import Images from "../Images";
import moment from "moment";
import { onAmountChange } from "../../../redux/actions/betSlipActions";
import { setPossibleWinnings  , setTotalStake} from "../../../redux/actions/betSlipActions";
import CustomDropdown from "./CustomDropDown";
import { ClearBetBuilder } from "../../../redux/actions/betSlipActions";
const Option = Select.Option;

class CustomBetRow extends React.Component {
  state = {
    changeStatus: 0,
    selection: this.props.betSlipField.selectedDrawsIds && this.props.betSlipField.selectedDrawsIds
  };
  checkImage = (teamId) => {
    this.setState({
      [teamId]: true,
    });
  };


  onAmountClick = (e, action, amount, betSlipField, selectedCurrency) => {
    e.preventDefault();
    let currentAmount = parseInt(amount);
    switch (action) {
      case "up":
        currentAmount += selectedCurrency.currencyId === 1 ? 10 : 1;
        break;

      case "down":
        if (currentAmount - (selectedCurrency.currencyId === 1 ? 10 : 1) >= 0) {
          currentAmount -= selectedCurrency.currencyId === 1 ? 10 : 1;
        } else {
          currentAmount = 0;
        }
        break;
    }
    this.props.onFieldAmountChange(
      currentAmount,
      betSlipField.activeOddFieldId
    );
    this.props.handleHideStake();
  };

  componentDidUpdate(prevProps, prevState) {

    if (this.props.betSlipField.oddValue !== prevProps.betSlipField.oddValue) {
      this.setState({ changeStatus: 0 }, () => {
        setTimeout(
          () =>
            this.setState({
              changeStatus: this.props.betSlipField.oddValueStatus,
            }),
          10
        );
      });
    }
  }
  render() {
    const {
      betSlipField,
      loadingPlaceBet,
      memberSelectedCurrency,
      isDark,
      totalStake,
      betTypesList
    } = this.props;
    let betTab = SessionStorage.betTab;
    const selectedCurrency =
      memberSelectedCurrency || Cookies.get("selectedCurrency");
    const spinner = (
      <Icon type="loading" style={{ fontSize: 24 }} spin={loadingPlaceBet} />
    );
    let hasResponse = betSlipField.response !== undefined;
    return (
      <div className="event">
        <div style={{ display: "flex", flexDirection: "row" }} className="text">
          <div
            style={{ width: "80%", display: "flex", flexDirection: "column" }}
          >
            {/* <SportIcon
              feedId={betSlipField.feed.feedId}
              sportId={betSlipField.sport.sportId}
            /> */}
            <div
              className="teams"
              // onClick={() => this.navToDrillDown()}
              style={{
                width: "90%",
                display: "inline-block",
                justifyContent: "center",
              }}
            >

              <div className="bet-slip-teams-container">
                {betSlipField.feed.feedId === Enums.Feed.Casino ||
                betSlipField.feed.feedId === Enums.Feed.SpinAndWin ? (
                  <div>
                    {betSlipField.eventDisplayName} -{" "}
                    {betSlipField.eventBetLineNo}
                  </div>
                ) : (
                  <div>
                    {betSlipField.feed.feedId === Enums.Feed.LuckyNumbers ? (
                      <>
                        <div className="bet-slip-teams">
                          <span className="team-name-abbreviation">
                            {betSlipField &&
                              betSlipField.eventTournament &&
                              betSlipField.eventTournament
                                .tournamentDisplayName}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="bet-slip-teams">
                          <span className="team-name-abbreviation">
                            {betSlipField.homeTeamName &&
                              betSlipField.homeTeamName[0]}
                            {betSlipField.homeTeamName &&
                              betSlipField.homeTeamName.split(" ").length > 1 &&
                              betSlipField.homeTeamName.split(" ")[1][0]}
                          </span>
                          {betSlipField.feed.feedId != Enums.Feed.Casino &&
                            betSlipField.feed.feedId != Enums.Feed.SpinAndWin &&
                            betSlipField.eventDisplayName && (
                              <span>
                                {" "}
                                {betSlipField.eventDisplayName.split("Vs.")[0]}
                              </span>
                            )}
                          {betSlipField.feed.feedId == Enums.Feed.Casino ||
                            (betSlipField.feed.feedId ==
                              Enums.Feed.SpinAndWin &&
                              `- ${betSlipField.eventBetLineNo}`)}

                          <span style={{ fontSize: "16px" }}>
                            <p
                              style={{
                                color: "#2d8af7",
                                display: "inline",
                                fontWeight: "bold",
                                fontSize: "13px",
                              }}
                            >
                              Vs{" "}
                            </p>
                          </span>
                        </div>
                        <div className="bet-slip-teams">
                          <span className="team-name-abbreviation">
                            {betSlipField.awayTeamName &&
                              betSlipField.awayTeamName[0]}
                            {betSlipField.awayTeamName &&
                              betSlipField.awayTeamName.split(" ").length > 1 &&
                              betSlipField.awayTeamName.split(" ")[1][0]}
                          </span>
                          <span>
                            {betSlipField.eventDisplayName &&
                              betSlipField.eventDisplayName.split("Vs.")[1]}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="icon">
              {betSlipField.errors &&
                betSlipField.errors.length > 0 &&
                betTab == 2 && (
                  <Tooltip
                    title={betSlipField.errors.map((item, index) => (
                      <div key={index}>{` * ${item}`}</div>
                    ))}
                  >
                    <div className="alert-icon error">!</div>
                  </Tooltip>
                )}
            </div>
            {betTypesList && betTypesList.length > 0 &&  betTypesList.map(betType=>{
              return(
                <>
                <div style={{display:"flex",gap:"2px"}}>
              <div className="text">
                <div
                  style={{ opacity: "0.5", fontSize: "12px" }}
                  className="odd-name"
                >
                  {betType.betTypeName},
                </div>
              </div>
              <div className="text odds">
                <div className="icon" />
                <div>
                  <div className="team">{betType.oddFieldDisplayName}</div>
                </div>
              </div>
              </div>
                </>
              )
       
            }) }

          </div>
          {/* separator comment */}

          <div
            style={{
              width: "20%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              className="close"
              onClick={() => this.removeField()}
            >
              <img
                src={
                  localStorage.getItem("theme") &&
                  localStorage.getItem("theme") == "dark"
                    ? Images.BinIcon
                    : Images.RedBinIcon
                }
                alt="bin-icon"
                height="17px"
                width="17px"
              />
              {/* <Icon type="delete" theme="filled"/> */}
            </div>
            <div
              className={`odd-value`}
            >
              {totalStake ? (totalStake.toFixed(2)) : (
                <Icon type="lock" />
              )}
            </div>
          </div>
        </div>

        {/* ====================================================================== */}
        {/* Mounting component and possible winnings score in the uppper of the bits details component */}
        {loadingPlaceBet &&
          betTab == 1 &&
          (!hasResponse || betSlipField.response.type === "error") && (
            <Spin indicator={spinner} />
          )}
        {betSlipField.errors &&
          betSlipField.errors.length > 0 &&
          betTab == 1 &&
          betSlipField.errors.map((item, index) => (
            <Alert key={index} message={item} type="error" icon="!" />
          ))}
        {betSlipField.oddValueStatus !== 0 && (
          <Alert message={"Bet value changed"} type="warning" icon="!" />
        )}
        {hasResponse && betSlipField.response.type === "success" && (
          <div style={{ background: "#00800036" }}>
            <Alert
              key={betSlipField.response.betLine}
              message={betSlipField.response.message}
            />
          </div>
        )}
        {hasResponse && betSlipField.response.type === "error" && (
          <Alert
            key={betSlipField.response.betLine}
            type={betSlipField.response.type}
            icon={"!"}
            message={betSlipField.response.message}
          />
        )}
      </div>
    );
  }

  removeField(field) {
    const {ClearBetBuilder} = this.props;
    SessionStorage.betBuilderAmount= null;
	  SessionStorage.betBuilderDisplayOdds= null;
	  SessionStorage.betBuilderPossibleWinning= null;
	  SessionStorage.betBuilder= null;
    ClearBetBuilder()
  } 

  navToDrillDown() {
    const { history, feedName, match, betSlipField, feedId } = this.props;
    if (
      match.params.feed == Enums.Feed.Casino ||
      match.params.feed == Enums.Feed.SpinAndWin
    )
      history.push(
        `/${feedName}/${match.params.feed}/${match.params.sport}/${betSlipField.eventDisplayName}/${betSlipField.eventId}`
      );
    else
      history.push(
        `/${feedName}/${feedId}/${match.params.sport}/${match.params.sportName}/event/${betSlipField.eventCategory.sportCategoryId}/${betSlipField.eventTournament.tournamentId}/${betSlipField.eventId}`
      );
  }
}

const mapStateToProps = (_, initialProps) => (state) => {
  return {
    betSlipField: state.betSlip.customBetData[initialProps.data.activeOddFieldId],
    amount: state.betSlip.betBuilderAmount,
    memberSelectedCurrency: state.member.selectedCurrency,
    isDark: state.app.isDark,
    possibleWinnings: state.betSlip.betBuilderPossibleWinning,
    totalStake: state.betSlip.betBuilderTotalOdds,

  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    handleHideStake: () => {
      dispatch(handleHideStake());
    },
    onAmountChange: (amount) => {
      dispatch(onAmountChange(amount));
    },
    setTotalStake: (value) => {
      dispatch(setTotalStake(value));
    },
    setPossibleWinnings: (value) => {
      dispatch(setPossibleWinnings(value));
    },
    ClearBetBuilder: () => {
      dispatch(ClearBetBuilder());
    },
    
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CustomBetRow);
